<template>
  <div class="col px-0">
    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <div class="text-subtitle-1 text-sm-h6 text-md-h5 font-weight-bold text-center">
      Relatório de Inventário de Estoque
    </div>

    <v-card>
      <v-card-title>
        <span>Filtros</span>
      </v-card-title>
      <v-card-text>
        <v-row>
          <!-- <v-col cols="5">
            <v-autocomplete
              v-model="harvestId"
              label="Safra"
              :items="harvestList"
              item-value="id"
              item-text="name"
              @change="loadCulturesFromHarvest"
              clearable
              @click:clear="harvestId = null; cultureList = []; cultureId = null"
              :loading="harvestListLoading"
            />
          </v-col>

          <v-col cols="5">
            <v-autocomplete
              v-model="cultureId"
              label="Cultura (opcional)"
              :items="cultureList"
              item-value="id"
              item-text="name"
              :disabled="!harvestId"
              clearable
              @click:clear="cultureId = null"
              @change="loadPeriodsFromHarvestAndCulture"
              :loading="cultureListLoading"
              hint="Se nenhuma cultura for selecionada, todas serão exibidas"
              persistent-hint
            />
          </v-col> -->

          <v-col cols="12" sm="12" md="7">
            <v-autocomplete
              v-model="stockIds"
              label="Estoque(s)"
              :items="stockList"
              item-value="id"
              item-text="name"
              clearable
              @click:clear="stockIds = []"
              :loading="stockListLoading"
              multiple
              chips
              dense
              deletable-chips
              hint="Selecione pelo menos 1 estoque"
              persistent-hint
            />
          </v-col>

          <v-col cols="12" sm="6" md="3">
            <v-switch 
              v-model="showEmptyItems" 
              inset 
              label="Exibir Itens Zerados">
            </v-switch>
          </v-col>

          <v-col cols="12" sm="6" md="2">
            <v-btn 
              @click="loadStockInventoryReport"
              :disabled="stockIds.length < 1"
              class="mt-2"
            >
              <v-icon left>mdi-magnify</v-icon>
              Filtrar
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <div>
      <BasePrint
        printableElementId="stockInventoryReportTable"
        printButtonLabel="Imprimir"
        printTitle="Relatório de Inventário de Estoque"
        @start-printing="printing = loading = true"
        @stop-printing="printing = loading = false"
        v-if="stockInventory"
        class="mt-3"
      />
    </div>

    <div id="stockInventoryReportTable">
      
      <v-row>
        <v-col cols="12" v-for="stock in stockInventory" :key="stock.name+'stock'">
          <BaseIndex
            ref="baseIndex"
            :loading="loading"
            :pageLoading="pageLoading"
            :table-headers="tableHeaders"
            :table-items="stock.items"
            :indexNested="true"
            :disablePagination="true"
            :containTopToolbar="false"
            :maskFields="maskFields"
            :hasTableTitle="true"
            :tableTitle="'Inventário do Estoque: ' + stock.name"
          />
        </v-col>
      </v-row>
    </div>
    
  </div>
</template>

<script>
import gql from 'graphql-tag'
import moment from "moment";
import BaseIndex from "@shared_components/base_index.vue";
import DateRangeField from "@shared_components/date_range_field.vue"
import BasePrint from "@shared_components/base_print.vue";

export default {
  data() {
    return {
      tableItems: [],
      stockInventory: null,
      pageLoading: false,
      loading: false,
      showEmptyItems: false,
      stockListLoading: false,
      stockList: [],
      stockIds: [],
      tableHeaders: [
        { text: "Item", align: "left", sortable: true, value: "name" },
        { text: "Grupo", align: "left", sortable: true, value: "group" },
        { text: "Embalagem", align: "left", sortable: true, value: "packaging" },
        // { text: "Unidade", align: "left", sortable: true, value: "item.unit.name" },
        { text: "Quantidade em Estoque", align: "left", sortable: true, value: "availableQuantity" },
        { text: "Quantidade em Inventário", align: "left", sortable: true, value: "inventoryQuantity" },
        { text: "Localização", align: "left", sortable: true, value: "inventoryLocation" },
        // { text: "deleted", value: "_destroy", align: ' d-none', sortable: false, filter: value => value ? !value : true },
        // { text: "Ações", value: "action", sortable: false }
      ],
      maskFields: [
        { field: 'availableQuantity', mask: 'number_row_unit', unit: 'unit' },
        { field: 'inventoryQuantity', mask: 'blank_field_row_unit', unit: 'unit' },
        { field: 'inventoryLocation', mask: 'blank_field' },
      ]
    };
  },
  props: {
  },
  components: {
    BaseIndex: BaseIndex,
    DateRangeField: DateRangeField,
    BasePrint: BasePrint,
  },
  created() {
    this.loadAllStocks();
  },
  mounted() { 
  },
  computed: {
    // tableHeaders: function () { }
  },
  methods: {
    loadStockInventoryReport: function() {
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_STOCK_INVENTORY_REPORT,
          variables: {
            // harvestId: this.harvestId, 
            // cultureId: this.cultureId, 
            stockIds: this.stockIds,
            showEmptyItems: this.showEmptyItems
          },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          this.stockInventory = response.data.accountContext.stockInventoryReport;
          // console.log("stockInventory", this.stockInventory);
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
    },
    loadAllStocks: function() {
      this.stockListLoading = true;
      this.$apollo
        .query({
          query: LOAD_ALL_STOCKS_QUERY,
          // variables: {
          //   harvestId: this.harvestId,
          //   cultureId: this.cultureId
          // },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          this.stockList = response.data.accountContext.allStocks;
          this.stockIds = [];
        })
        .catch(response => console.log(response))
        .finally(() => (this.stockListLoading = false));
    },
    // getCostByPeriodId: function(periodsList, periodId) {
    //   let period = periodsList.find(period => period.periodId == periodId);
    //   if (period) {
    //     return period.cost;
    //   } 
    //   return 0;
    // },
    // getCostHaByPeriodId: function(periodsList, periodId) {
    //   let period = periodsList.find(period => period.periodId == periodId);
    //   if (period) {
    //     return period.costHa;
    //   } 
    //   return 0;
    // },
    // loadAllStocks: function() {
    //     this.stockListLoading = true;
    //     this.$apollo
    //       .query({
    //         query: LOAD_ALL_HARVEST_QUERY,
    //         fetchPolicy: "no-cache"
    //       })
    //       .then(response => {
    //         this.harvestList = response.data.accountContext.allHarvests;
    //       })
    //       .catch(response => console.log(response))
    //       .finally(() => (this.harvestListLoading = false));
    // },
    // loadCulturesFromHarvest: function() {
    //   if (this.harvestId){
    //     this.cultureListLoading = true;
    //     this.$apollo
    //       .query({
    //         query: CULTURES_FROM_HARVEST_QUERY,
    //         variables: {
    //           harvestId: this.harvestId
    //         },
    //         fetchPolicy: "no-cache"
    //       })
    //       .then(response => {
    //         this.cultureList = response.data.accountContext.allCulturesFromHarvest;
    //         this.cultureId = null;
    //         this.periodIds = [];
    //       })
    //       .catch(response => console.log(response))
    //       .finally(() => (this.cultureListLoading = false));
        
    //     this.loadPeriodsFromHarvestAndCulture();
    //   }
    // },
  }
};



const LOAD_STOCK_INVENTORY_REPORT = gql `
query ($stockIds: [ID!]!, $showEmptyItems: Boolean!) {
  accountContext {
    stockInventoryReport(stockIds: $stockIds, showEmptyItems: $showEmptyItems)
  }
}
`;

// const LOAD_ALL_HARVEST_QUERY = gql `
//   {
//     accountContext {
//       allHarvests {
//         id
//         name
//       }
//     }
//   }
// `;

// const CULTURES_FROM_HARVEST_QUERY = gql `
//   query ($harvestId: ID!) {
//     accountContext {
//       allCulturesFromHarvest(harvestId: $harvestId){
//         id
//         name
//       }
//     }
//   }
// `;

const LOAD_ALL_STOCKS_QUERY = gql `
  {
    accountContext {
      allStocks{
        id
        name
      }
    }
  }
`;

</script>

<style scoped>
  /* ::v-deep .cash_inflow_item {
    color: blue;
  }
  ::v-deep .cash_outflow_item {
    color: red;
  }
  ::v-deep .group_type {
    background-color: #ffdc9d;
    font-weight: bold;
  }
  ::v-deep .direct_cost {
    background-color: #60bd60;
    font-weight: bold;
  }
  ::v-deep .service_provision_cost {
    background-color: #60bd60;
    font-weight: bold;
  }
  ::v-deep .indirect_cost {
    background-color: #60bd60;
    font-weight: bold;
  }

  ::v-deep .total_cost {
    background-color: red;
    color: white;
    font-weight: bold;
  }
  ::v-deep .total_cost:hover {
    color: black;
  }
  
  ::v-deep .area_cost {
    background-color: darkgreen;
    color: white;
    font-weight: bold;
  }
  ::v-deep .area_cost:hover {
    color: black;
  }

  ::v-deep .unit_production_cost {
    background-color: darkgreen;
    color: white;
    font-weight: bold;
  }
  ::v-deep .unit_production_cost:hover {
    color: black;
  }
  
  ::v-deep .unit_cost {
    background-color: darkgreen;
    color: white;
    font-weight: bold;
  }
  ::v-deep .unit_cost:hover {
    color: black;
  }
  
  
  ::v-deep .total_revenue {
    background-color: #007eff;
    color: white;
    font-weight: bold;
  }
  ::v-deep .total_revenue:hover {
    color: black;
  }

  ::v-deep .period_result {
    background-color: yellow;
  }

  ::v-deep .area_result {
    background-color: yellow;
  }
  ::v-deep .unit_result {
    background-color: yellow;
  }
  ::v-deep .net_income {
    background-color: yellow;
  } */
</style>
